import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useMediaQuery } from 'react-responsive';
import { Carousel, Column, Container, Row } from '@pella/sash-framework';
import { CTA } from '../../';
import { contentstackClient } from '../../../utils/contentstack-client';
import { GET_ARTICLES_BY_TAXONOMY } from '../../../enums/contentstack-graphql';
import { isValidArray } from '../../utilities/validations';
import ArticleCard from '../article-card';

const BeforeAfterCarousel = ({ data, dynamic, className, ...other }) => {
	const filters = isValidArray(dynamic?.filter_tags) ? dynamic.filter_tags.map((filter) => ({ taxonomies: { filter_by: { term_in: filter?.split(', ') } } })) : [];
	const { data: articles } = useQuery(GET_ARTICLES_BY_TAXONOMY, { client: contentstackClient, variables: { filters: filters, limit: 7 }, skip: !isValidArray(dynamic?.filter_tags) });
	const isMobile = useMediaQuery({ maxWidth: 767 });

	if (!isValidArray(articles?.all_articles?.items)) return null;

	const renderCarouselGradients = (color) => {
		switch (color) {
			case '#F2F2F2':
				return 'before:from-gray-5 after:from-gray-5';
			case '#F9F9F9':
			case '#F8F9FA':
				return 'before:from-gray-3 after:from-gray-3';
			default:
				return 'before:from-white after:from-white';
		}
	};

	return (
		<div
			className={`beforeAfterCarousel py-8 xl:py-9 ${className || ''}`}
			data-testid='before-after-carousel'
			style={data.background_hex_value ? { backgroundColor: data.background_hex_value } : null}
			{...other}
		>
			{data?.heading && (
				<Container className='mb-6 xl:mb-8'>
					<Row align='center'>
						<Column
							xs={12}
							md='fluid'
						>
							<h2 className='text-h3 mb-0'>{data.heading}</h2>
						</Column>

						{!isMobile && isValidArray(dynamic.ctas) && (
							<Column md='auto'>
								<CTA data={dynamic.ctas[0]} />
							</Column>
						)}
					</Row>
				</Container>
			)}

			<Container noPadding>
				<Carousel
					className={`beforeAfter-slider before:z-2 before:from-gray-3 after:from-gray-3 max-md:scroll-px-6 max-md:px-6 ${renderCarouselGradients(data.background_hex_value)}`}
					arrowsClassName='max-2xl:[&>li:first-child>button]:left-2 max-2xl:[&>li:last-child>button]:right-2'
					slidesToShow={{ xs: 1, sm: 1.5, md: 2 }}
					slidePadding={16}
					showSlideHints
					showArrows
					showDots
				>
					{articles.all_articles.items.map((article, index) => (
						<ArticleCard
							key={index}
							data={article}
							showCta={false}
						/>
					))}
				</Carousel>
			</Container>

			{isMobile && isValidArray(dynamic.ctas) && (
				<Container className='mt-8 text-center'>
					<CTA data={dynamic.ctas[0]} />
				</Container>
			)}
		</div>
	);
};

BeforeAfterCarousel.propTypes = {
	dynamic: PropTypes.object,
	data: PropTypes.object,
	className: PropTypes.string,
};

export default BeforeAfterCarousel;
